import React from "react"
import { FormProvider } from "react-hook-form"

import { FormProviderProps } from "shared/types/ReactHookForm"

import { InstallationReferenceFilterState } from "entities/building-references/types/InstallationReferenceFilterState"
import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

import { InstallationReferenceBuildingTypeFilterInput } from "./inputs/InstallationReferenceBuildingTypeFilterInput"
import { InstallationReferenceProductFilterInput } from "./inputs/InstallationReferenceProductFilterInput"
import { InstallationReferenceRoomTypeFilterInput } from "./inputs/InstallationReferenceRoomTypeFilterInput"

export interface InstallationReferenceFilterViewModel {
  productFilterOptions: ProductSelectOption[]
  form: FormProviderProps<InstallationReferenceFilterState>
}

export const InstallationReferenceFilterView = React.memo(
  ({ productFilterOptions, form }: InstallationReferenceFilterViewModel) => (
    <FormProvider {...form}>
      <form
        id="installation-reference-filter"
        className="installation-reference-filter"
      >
        <InstallationReferenceProductFilterInput
          options={productFilterOptions}
          loading={productFilterOptions === undefined}
        />
        <InstallationReferenceRoomTypeFilterInput />
        <InstallationReferenceBuildingTypeFilterInput />
      </form>
    </FormProvider>
  )
)
